module.exports = __webpack_public_path__ + "static/media/whatsapp.45c6e6ec.svg";